export enum FileSorting {
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TimeCreated = 'time_add_asc',
  TimeUpdated = 'time_update_asc'
}



// WEBPACK FOOTER //
// ./src/app/models/file-sorting.enum.ts